import { RecaptchaDirective } from './directives/recaptcha.directive';
import { InfographicsComponent } from './components/pages/home/infographics/infographics.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Injectable, NgModule } from '@angular/core';
import { AppRoutingModule } from './/app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';

import { HeaderComponent } from './components/template/header/header.component';
import { ClsdataComponent } from './components/pages/clsdata/clsdata.component';
import { ClspiComponent } from './components/pages/clspi/clspi.component';
import { NotfoundComponent } from './components/pages/notfound/notfound.component';
import { TeamCarouselComponent } from './components/shared/team-carousel/team-carousel.component';
import { ClsgroupservicesComponent } from './components/pages/clsgroupservices/clsgroupservices.component';
import { EventsComponent } from './components/shared/events/events.component';
import { NewsComponent } from './components/shared/news/news.component';
import { WorkingWithComponent } from './components/shared/working-with/working-with.component';
import { CookieNoticeComponent } from './components/shared/cookie-notice/cookie-notice.component';
import { UnsupportedBrowserComponent } from './components/shared/unsupported-browser/unsupported-browser.component';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { ArticleViewComponent } from './components/shared/article-view/article-view.component';
import { EventViewComponent } from './components/shared/event-view/event-view.component';
import { Angulartics2Module } from 'angulartics2';

import { DRiskComponent } from './components/pages/d-risk/d-risk.component';
import { CurrencyPipe } from '@angular/common';

import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { LoggingService } from './ordering-platform/shared/abstraction/LoggingService';
import { LogService } from './ordering-platform/services/LogService';
import { URLLinkingService } from './ordering-platform/services/url-linking.service';
import { ExpiredDraftComponent } from './ordering-platform/case-details/components/expired-draft-dialog/expired-draft-dialog.component';
import { CannotConvertComponent } from './ordering-platform/case-details/components/cannot-convert-dialog/cannot-convert-dialog.component';
import { MatMenuModule } from '@angular/material/menu';

@Injectable()
export class NoCacheHeadersInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const authReq = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      }
    });
    return next.handle(authReq);
  }
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ClsdataComponent,
    ClspiComponent,
    NotfoundComponent,
    TeamCarouselComponent,
    ClsgroupservicesComponent,
    EventsComponent,
    NewsComponent,
    WorkingWithComponent,
    CookieNoticeComponent,
    UnsupportedBrowserComponent,
    ArticleViewComponent,
    EventViewComponent,
    DRiskComponent,
    InfographicsComponent,
    RecaptchaDirective,
    ExpiredDraftComponent,
    CannotConvertComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    DeviceDetectorModule.forRoot(),
    HttpClientModule,
    Angulartics2Module,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatMenuModule,
    ToastrModule.forRoot({ preventDuplicates: true, timeOut: 10000 }) // Prevent all toasters from duplicating and disappear after 10 seconds.
  ],
  exports: [
    MatInputModule,
    MatMenuModule,
  ],
  providers: [
    CurrencyPipe,
    {
      provide: LoggingService,
      useClass: LogService
    },
    URLLinkingService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheHeadersInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
